"use client";
import { useState } from "react";

export function useWorkReporting() {
  const [isWorking, setIsWorking] = useState(false);

  async function doWithWorkReporting<T>(action: () => Promise<T>): Promise<T> {
    setIsWorking(true);
    try {
      const ret: T = await action();
      return ret;
    } catch (reason) {
      console.log(reason);
      throw reason;
    } finally {
      setIsWorking(false);
    }
  }

  return { isWorking, doWithWorkReporting };
}
